<template>
  <div>
    <LoadingSpinner class="page-loading" :isLoading="isLoading" />
  </div>

  <div class="container-fluid">
    <header class="main-header main-header-container">
      <h1 v-if="material.equipmentGroup == equipmentGroup.Equipment" class="main-title">Noodmaterieel toevoegen</h1>
      <h1 v-if="material.equipmentGroup == equipmentGroup.Material" class="main-title">Noodmateriaal toevoegen</h1>
    </header>

    <form @submit.prevent="formSubmit">
      <div class="row">
        <div class="col">
          <div class="card">
            <div class="card-body">
              <h5>Algemeen</h5>
              <div class="row g-3">
                <div class="col-md-6">
                  <label for="equipmentGroup">Groep <span class="required">*</span></label>
                  <select class="form-select" name="equipmentGroup" v-model="material.equipmentGroup"
                    @change="handleEquipmentGroupChange">
                    <option selected :value="equipmentGroup.Material">Materiaal</option>
                    <option :value="equipmentGroup.Equipment">Materieel</option>
                  </select>
                  <div class="invalid-feedback">
                    <span v-if="errors.EquipmentGroup">{{ errors.EquipmentGroup.join(', \n')  }}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label for="typeId">Materiaal type<span class="required">*</span></label>
                  <select id="typeId" class="form-select" name="typeId" v-model="material.typeId">
                    <option disabled selected value="">Kies type</option>
                    <option v-for="equipmentType in equipmentTypes" :key="equipmentType.id" :value="equipmentType.id">
                      {{ equipmentType.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <div v-if="errors.TypeId">{{ errors.TypeId.join(', \n') }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <label v-if="material.equipmentGroup == equipmentGroup.Material" for="name">Afmetingen <span
                      class="required">*</span></label>
                  <label v-if="material.equipmentGroup == equipmentGroup.Equipment" for="name">Afmetingen</label>
                  <input id="name" type="text" class="form-control" name="name" v-model="material.dimensions" />

                  <div class="invalid-feedback">
                    <div v-if="errors.Dimensions">{{ errors.Dimensions.join(', \n') }}</div>
                  </div>
                </div>
                <div  v-if="material.equipmentGroup == equipmentGroup.Material" class="col-md-6">
                  <label for="material">Materiaal</label>
                  <input id="material" type="text" class="form-control" name="material" v-model="material.material" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Material" class="col-md-6">
                  <label for="comment">Opmerking</label>
                  <input id="comment" type="text" class="form-control" name="comment" v-model="material.comment" />
                </div>
                <div class="col-md-6">
                  <label for="location">Standplaats <span class="required">*</span></label>
                  <select id="location" class="form-select" name="location" v-model="material.locationId">
                    <option disabled selected value="">Kies standplaats</option>
                    <option v-for="location in locations" :key="location.id" :value="location.id">
                      {{ location.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">
                    <div v-if="errors.LocationId">{{ errors.LocationId.join(', \n') }}</div>
                  </div>
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="disposal">Afvoer (M<sup>3</sup>/U)</label>
                  <input id="disposal" type="number" class="form-control" name="disposal" v-model="material.disposal" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="suctionHose">Zuigslang (M)</label>
                  <input id="suctionHose" type="number" class="form-control" name="suctionHose"
                    v-model="material.suctionHose" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="drainHose">Afvoerslang (M)</label>
                  <input id="drainHose" type="number" class="form-control" name="drainHose"
                    v-model="material.drainHose" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="power">Vermogen</label>
                  <input id="power" type="number" class="form-control" name="power" v-model="material.power" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="curves">Bochten</label>
                  <input id="curves" type="text" class="form-control" name="curves" v-model="material.curves" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="fuel">Brandstof</label>
                  <select id="fuel" class="form-select" name="fuel" v-model="material.fuel">
                    <option selected :value=null disabled>Kies brandstof</option>
                    <option selected value="" disabled style="display:none;"></option>
                    <option value="">Geen</option>
                    <option value=0>Benzine</option>
                    <option value=1>Diesel</option>
                    <option value=2>Diesel Euro-6</option>
                  </select>
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="comment">Overige specificaties</label>
                  <input id="comment" type="text" class="form-control" name="comment" v-model="material.comment" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="stationary">Stationair</label>
                  <input id="stationary" type="checkbox" name="stationary" v-model="material.stationary" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="transportByTrailer">Vervoer via aanhanger</label>
                  <input id="transportByTrailer" type="checkbox" name="transportByTrailer"
                    v-model="material.transportByTrailer" />
                </div>
                <div v-if="material.equipmentGroup == equipmentGroup.Equipment" class="col-md-6">
                  <label for="electricalConnection">Elektrische aansluiting</label>
                  <input id="electricalConnection" type="checkbox" name="electricalConnection"
                    v-model="material.electricalConnection" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="actions">
        <router-link :to="{ name: 'EmergencyEquipmentOverview' }" class="btn btn-gray">Annuleren
        </router-link>
        <button type="submit" class="btn btn-primary-dark ms-3">Opslaan</button>
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner,
  },
  name: "EmergencyEquipmentAdd",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      equipmentGroup: {
        Material: 0,
        Equipment: 1,
      },
      errors: [],
      isLoading: false,
      equipmentTypes: [],
      locations: [],
      material: {
        typeId: 0,
        equipmentGroup: 0,
        status: 0,
        dimensions: "",
        locationId: 0,
      },

    };
  },

  watch: {
    "$route.params.id}": {
      handler: function () {
        this.getEquipmentTypeData();
        this.getLocationData();
      },
    },
  },

  mounted() {
    this.getEquipmentTypeData();
    this.getLocationData();
  },

  methods: {
    getEquipmentTypeData() {
      this.isLoading = true;

      Promise.all([
        this.$axiosInstance.get(
          `${process.env.VUE_APP_API}/EmergencyEquipmentType`,
          {
            params: {
              equipmentGroup: this.material.equipmentGroup,
            },
          }
        ),
      ])
        .then(([equipmentTypes]) => {
          if ((equipmentTypes.data !== "")) {
            this.equipmentTypes = equipmentTypes.data;
          }
        })
        .catch(() => {
          this.$toast.open({
            message:
              "Basis informatie van noodmaterialen kon niet worden opgehaald.",
            type: "error",
            position: "top-right",
            duration: 5000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getLocationData() {
      this.isLoading = true;

      this.$axiosInstance
        .get(`${process.env.VUE_APP_API}/EmergencyEquipmentLocation`)
        .then((response) => {
          if ((response.data !== "")) {
            this.locations = response.data;
          }
        })
        .catch(() => {
          this.$toast.open({
            message: "Locaties konden niet worden opgehaald.",
            type: "error",
            position: "top-right",
            duration: 5000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    sendData() {
      this.isLoading = true;
      this.errors = [];

      this.$axiosInstance
        .post(`${process.env.VUE_APP_API}/EmergencyEquipment`, this.material)
        .then((response) => {
          if (response.data.status === 400) {
            this.errors = response.data.errors;
            this.$toast.open({
              message: "Er zijn één of meer validatiefouten opgetreden.",
              type: "warning",
              position: "top-right",
              duration: 5000,
            });
          } else {
            this.$toast.open({
              message: "Materiaal successvol opgeslagen!",
              position: "top-right",
              duration: 5000,
            });
            this.$router.push({ name: 'EmergencyEquipmentOverview' })
          }
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.$toast.open({
            message: "Opslaan mislukt. Probeer het a.u.b. opnieuw.",
            type: "error",
            position: "top-right",
            duration: 5000,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    handleEquipmentGroupChange() {
      this.material.typeId = 0;
      this.getEquipmentTypeData();
    },

    formSubmit() {
      this.v$.$validate();
      if (!this.v$.$error) {
        this.sendData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.invalid-feedback {
  display: block;
}

.actions {
  margin-top: $spacer * 1.5;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    min-width: 7.5rem;
  }
}

.row {
  margin-bottom: $spacer;
}

.card-body label {
  width: 100%;
}

.card-body input[type="checkbox"] {
  margin-top: 13px;
}
</style>
